import { useNetwork } from '@tribeplatform/react-sdk/hooks'

export const GoogleSEOCard = ({ title, description }) => {
  const { data: network } = useNetwork()
  const { domain } = network || {}

  return (
    <div
      className="relative block subpixel-antialiased rounded-sm text-md"
      style={{ fontFamily: 'Arial, sans-serif' }}
    >
      <span
        className="block cursor-pointer truncate text-lg hover:underline"
        style={{ color: '#1a0dab' }}
      >
        {title}
      </span>
      <div
        className="whitespace-nowrap border-b sm:border-none sm:p-0 sm:m-0"
        style={{
          borderColor: '#ddd',
          height: '17px',
          paddingBottom: '22px',
          marginBottom: '6px',
        }}
      >
        <span
          className="relative text-sm"
          style={{ top: '-2px', color: '#006621' }}
        >
          {/* eslint-disable-next-line react/jsx-no-literals */}
          {`https://${domain}/`}
        </span>
        <span
          className="hidden sm:inline-block"
          style={{
            verticalAlign: 'middle',
            marginTop: '-4px',
            marginLeft: '3px',
            borderWidth: '5px 4px 0 4px',
            borderStyle: 'solid',
            borderColor: '#006621 transparent',
          }}
        ></span>
      </div>
      <span
        style={{
          color: '#545454',
          fontSize: '13px',
          lineHeight: 1.4,
          wordWrap: 'break-word',
        }}
      >
        {description}
      </span>
    </div>
  )
}
